import { ColdIcon, WarmIcon, HotIcon, RemittanceIcon, InsuranceIcon, FinancingIcon, ReferralIcon, ReKYCIcon } from "../../lead-inventory/icons";

import AccountTableActions from "./accountTableActionButtons";
import SidebarTabsContents from "./sidebar-components/accountSidebar.jsx";
import { useState } from "react";

const AccountInventoryTable = ({ data, onSort, sortField, sortOrder }) => {
      const [showSidebar, setShowSidebar] = useState(false);
      const [leadID, setLeadID] = useState(null);
      const [churnLikelihood, setChurnLikelihood] = useState(null);
      const [profileName, setProfileName] = useState(null);
      const [relationship, setRelationship] = useState(null);
      const [leadName, setLeadName] = useState(null);
      const [hunterName, setHunterName] = useState(null);
  
      const handleDetailClick = (leadID) => {
        setShowSidebar(true);
        setLeadID(leadID);
        setChurnLikelihood(data.find((item) => item.lead_id === leadID)?.churn_profile);
        setProfileName(data.find((item) => item.lead_id === leadID)?.profile_name);
        setRelationship(data.find((item) => item.lead_id === leadID)?.relationship);
        setHunterName(data.find((item) => item.lead_id === leadID)?.hunter_username);
        setLeadName(data.find((item) => item.lead_id === leadID)?.name);
      };

    const getProfileStyle = (status) => {
      const styles = {
          'Fresh Meat': "bg-[#FFDAD4] border-[#FFDAD4] text-black",
          Dormant: "bg-[#DFE0FF] border-[#DFE0FF] text-black",
          Newbie: "bg-[#FFDAD4] border-[#FFDAD4] text-black",
          'Farmable (Avg.)': "bg-[#FFEDE9] border-[#FFEDE9] text-black",
          'Growth Potential': "bg-[#FFEDE9] border-[#FFEDE9] text-black",
          'Core Customer (Loyal)': "bg-[#FFEDE9] border-[#FFEDE9] text-black",
          Losers: "bg-[#DFE0FF] border-[#DFE0FF] text-black",
          'Farmable (Loose)': "bg-[#FFDAD4] border-[#FFDAD4] text-black",
          'Bargain Hunter': "bg-[#FFDAD4] border-[#FFDAD4] text-black",
          'Need-Based (Avg.)': "bg-[#FFEDE9] border-[#FFEDE9] text-black",
          'Farmable (Tight)': "bg-[#FFEEDC] border-[#FFEEDC] text-black",
          'Need-Based (Loose)': "bg-[#FFDAD4] border-[#FFDAD4] text-black",
          Wanderer: "bg-[#DFE0FF] border-[#DFE0FF] text-black",
          'Need-Based (Tight)': "bg-[#FFDAD4] border-[#FFDAD4] text-black",
          'Core Customer (Ex-GF)': "bg-[#DFE0FF] border-[#DFE0FF] text-black"
      };
      return styles[status] || "bg-gray-100 text-gray-600";
    };
    const getChurnStatusStyle = (status) => {
      const styles = {
          Activated: "bg-[#F5FAE5] border-[#F5FAE5] text-black",
          Dormant: "bg-[#FFF0F5] border-[#FFF0F5] text-black",
          Sabik: "bg-[#EBF8FF] border-[#EBF8FF] text-black",
          Sirius: "bg-[#FEFAD8] border-[#FEFAD8] text-black",
          Spica: "bg-[#FBF29D] border-[#FBF29D] text-black",
          Sargas: "bg-[#FFDDB6] border-[#FFDDB6] text-black"
      };
      return styles[status] || "bg-gray-100 text-gray-600";
    };

    return (
      <><div className="">
        <table className="min-w-full bg-white border-b border-gray-200 table-fixed">
          <thead key="thead">
            <tr key="header-row" className="text-gray-400 border-t">
              <th key="header-id" className="p-4 border-b text-left w-[5%]">ID</th>
              <th key="header-product" className="p-4 border-b text-left w-[5%]">Product</th>
              <th key="header-name" className="p-4 border-b text-left w-[25%]">Name</th>
              <th key="header-status" className="p-4 border-b text-left w-[10%]">Churn Likelihood</th>
              <th key="header-pipeline" className="p-4 border-b text-left w-[20%]">Profile Name</th>
              <th 
                key="header-source" 
                className="p-4 border-b text-left w-[15%] cursor-pointer hover:bg-gray-50 select-none"
                onClick={(e) => {
                  e.stopPropagation();
                  onSort && onSort('last_transaction_datetime');
                }}
              >
                <div className="flex items-center gap-1">
                  Last Transacted
                  {sortField === 'last_transaction_datetime' && (
                    <span className="text-gray-600">
                      {sortOrder === 'asc' ? '↑' : '↓'}
                    </span>
                  )}
                </div>
              </th>
              <th 
                key="header-interaction" 
                className="p-4 border-b text-left w-[15%] cursor-pointer hover:bg-gray-50 select-none"
                onClick={(e) => {
                  e.stopPropagation();
                  onSort && onSort('updated_time');
                }}
              >
                <div className="flex items-center gap-1">
                  Last Interacted
                  {sortField === 'updated_time' && (
                    <span className="text-gray-600">
                      {sortOrder === 'asc' ? '↑' : '↓'}
                    </span>
                  )}
                </div>
              </th>
              <th key="header-owner" className="p-4 border-b text-left w-[3%]">Owner</th>
              <th key="header-action" className="p-4 border-b text-left w-[2%]">Action</th>
            </tr>
          </thead>
          <tbody key="tbody">
            {data.length > 0 ? (
              data.map((item, index) => (
                <tr key={`row-${item.lead_id}-${index}`} 
                className="hover:bg-[#F7F7F7]"
                onClick={() => handleDetailClick(item.lead_id)}>
                  <td key={`id-${item.lead_id}`} className="p-4 border-b text-gray-500 text-left w-[5%]">{item.lead_id}</td>
                  <td key={`product-${item.lead_id}`} className="p-4 border-b text-left w-[5%]">
                    {item.products.includes('Remittance') && (
                      <img key={`remittance-${item.lead_id}`} src={RemittanceIcon} alt="Remittance" className="inline-block w-6 h-6 mr-2" />
                    )}
                    {item.products.includes('Insurance') && (
                      <img key={`insurance-${item.lead_id}`} src={InsuranceIcon} alt="Insurance" className="inline-block w-6 h-6 mr-2" />
                    )}
                    {item.products.includes('Financing') && (
                      <img key={`financing-${item.lead_id}`} src={FinancingIcon} alt="Financing" className="inline-block w-6 h-6 mr-2" />
                    )}
                    {item.products.includes('Referral') && (
                      <img key={`referral-${item.lead_id}`} src={ReferralIcon} alt="Referral" className="inline-block w-6 h-6 mr-2" />
                    )}
                    {item.products.includes('Re-KYC') && (
                      <img key={`rekyc-${item.lead_id}`} src={ReKYCIcon} alt="ReKYC" className="inline-block w-6 h-6 mr-2" />
                    )}
                  </td>
                  <td key={`name-${item.lead_id}`} className="p-4 border-b font-bold text-left w-[28%]">{item.name}</td>
                  <td key={`status-${item.lead_id}`} className="p-4 border-b text-left w-[10%]">
                    <span className={`w-[95px] h-[34px] pt-2 px-4 pb-2 gap-2 top-5 left-[22px] rounded-full border font-bold ${getChurnStatusStyle(item.churn_profile)}`}>
                      {item.churn_profile}
                    </span>
                  </td>
                  <td key={`pipeline-${item.lead_id}`} className="p-4 border-b text-left w-[20%]">
                    <span className={`w-[95px] h-[34px] pt-2 px-4 pb-2 gap-2 top-5 left-[22px] rounded-full border font-bold ${getProfileStyle(item.profile)}`}>
                      {item.profile || "Unknown"}
                    </span>
                  </td>
                  <td key={`interaction-last-transaction-${item.lead_id}`} className="p-4 border-b text-left w-[15%] font-bold">
                    {item.last_transaction_datetime}
                    <span key={`days-from-last-transaction-${item.lead_id}`} className="text-xs text-[#A96900] border-[#FFEEDC] bg-[#FFEEDC] w-2 h-2 p-1 ml-2 rounded-full border">
                      {item.days_from_last_transaction}
                    </span>
                  </td>
                  <td key={`interaction-last-interacted-${item.lead_id}`} className="p-4 border-b text-left w-[15%] font-bold">
                    {item.updated_time}
                    <span key={`last-interaction-${item.lead_id}`} className="text-xs text-[#A96900] border-[#FFEEDC] bg-[#FFEEDC] w-2 h-2 p-1 ml-2 rounded-full border">
                      {item.last_interacted}
                    </span>
                  </td>
                  <td key={`owner-${item.lead_id}`} className="p-4 border-b text-left w-[3%] font-bold">
                    <div className="relative group inline-block">
                      <span className="bg-[#EEEEEE] w-10 h-10 py-2 px-3 rounded-full inline-flex items-center justify-center">
                        {item.farmer_username ? item.farmer_username[0].toUpperCase() : ''}
                      </span>
                      <div className="absolute hidden group-hover:block bg-gray-800 text-white text-sm rounded py-1 px-2 -bottom-8 left-1/2 transform -translate-x-1/2 whitespace-nowrap">
                        {item.farmer_username ? item.farmer_username[0].toUpperCase() + item.farmer_username.slice(1) : 'No Owner'}
                      </div>
                    </div>
                  </td>
                  <td key={`action-${item.lead_id}`} className="p-4 border-b text-center w-[2%]"
                    onClick={(e) => e.stopPropagation()}>
                    <AccountTableActions leadId={item.lead_id} />
                  </td>
                </tr>
              ))
            ) : (
              <tr key="no-data-row">
                <td key="no-data-cell" colSpan="4" className="text-center py-4 text-gray-500 border-b">
                  No data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <SidebarTabsContents
          showSidebar={showSidebar}
          setShowSidebar={setShowSidebar}
          leadID={leadID}
          churnLikelihood={churnLikelihood}
          profileName={profileName}
          relationship={relationship}
          leadName={leadName}
          hunterName = {hunterName}
          />
        </>
    );
  };
  
  export default AccountInventoryTable;